module.exports = __webpack_public_path__ + "img/soujiki_g.55fbbf1c.png";